import gettext from '@sdk/lang/gettext';
import { TimesheetProjection } from '@sdk/timesheets/types/TimesheetProjection';
import Column from '@sdk/components/ui/spacing/Column';

import ModalRow from '@web/timeClock/modals/rows/ModalRow/ModalRow';
import AttestationsFromSingleProjection from '@web/timeClock/modals/rows/AttestationsRow/AttestationsFromSingleProjection';
import { AttestationsContainer } from '@web/timeClock/modals/rows/AttestationsRow/attestationsRow.styles';
import AttestationIconSvg from '@web/assets/svg/Icons/32/announcement-gray.svg';

type Props = {
  timesheetProjections: TimesheetProjection[];
};

const AttestationsRow = ({ timesheetProjections }: Props) => (
  <ModalRow label={gettext('Attestation')} icon={AttestationIconSvg}>
    <Column>
      {timesheetProjections.map(({ id, breakAttestations }) => (
        <AttestationsContainer key={id}>
          <AttestationsFromSingleProjection breakAttestations={breakAttestations} />
        </AttestationsContainer>
      ))}
    </Column>
  </ModalRow>
);

export default AttestationsRow;
